import { HFlow, Icon, Text } from 'bold-ui'

export function AlertCidadaoNaoAceitouCC() {
  return (
    <HFlow hSpacing={0.5} alignItems='center'>
      <Icon icon='exclamationTriangleOutline' fill='alert' size={1} />
      <Text color='alert'>
        O cidadão não concordou com o agendamento da consulta com o especialista mediada por tecnologia durante o
        atendimento em que houve a solicitação de cuidado compartilhado.
      </Text>
    </HFlow>
  )
}
